module.exports = __webpack_public_path__ + "img/svg/ps5-xboxxs.94b805bf605f459c2466ec1f15a05fca.svg";